import { render, staticRenderFns } from "./FacialDeviceTableControl.vue?vue&type=template&id=e6a3116e&scoped=true&"
import script from "./FacialDeviceTableControl.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a3116e",
  null
  
)

export default component.exports